import { hrefsDeCompite } from '@/features/compite/lib/rutas';
import { NotificationType, type Notification } from '../types/notification.types';

/**
 * Adónde lleva el clic en una notificación. Plan 2 de la épica H: el aviso de
 * una estrategia vencida abre su vuelta, ahora encima de Compite › Decisiones
 * (rediseño del 14-oct); el de una cotización del Pricer abre la ficha del
 * Pricer. null = no lleva a ningún lado (sólo se marca leída).
 */
export function destinoDeLaNotificacion(
  n: Pick<Notification, 'quoteId' | 'strategyApplicationId'> &
    Partial<Pick<Notification, 'pricerDatecQuoteId' | 'type' | 'monitorRunId'>>,
  /** Si el cargo de quien mira tiene la pantalla «Cotizaciones Datec». Por omisión, sí. */
  puedeVerElPricer = true
): string | null {
  // Un aviso de una cotización del Pricer lleva a SU ficha: `/quotes/<espejo>` no la muestra.
  // Sin la pantalla del Pricer la ficha da un 403: se lo lleva a Aprobaciones, donde ya puede decidir.
  if (n.pricerDatecQuoteId) {
    // El observador sin la pantalla no tiene nada que hacer en Aprobaciones: sólo se entera.
    if (
      !puedeVerElPricer &&
      (n.type === NotificationType.QUOTE_FOR_INFORMATION ||
        n.type === NotificationType.QUOTE_BUDGET_EXCEEDED)
    ) {
      return null;
    }
    return puedeVerElPricer ? `/pricer-datec/${n.pricerDatecQuoteId}` : '/approvals';
  }
  if (n.quoteId) return `/quotes/${n.quoteId}`;
  // Monitoreo (26-oct): precios nuevos de una estrategia → revisarlos, ya filtrados.
  if (n.type === NotificationType.PRICES_TO_DECIDE && n.strategyApplicationId) {
    return hrefsDeCompite.revisar({ estrategia: n.strategyApplicationId });
  }
  // Los precios aprobados salieron a la tienda → el historial de publicaciones (se pueden revertir).
  if (n.type === NotificationType.PRICES_PUBLISHED) return '/historial-push';
  // Demo que vence (2-nov): a la plataforma, la lista de empresas filtrada por ese estado.
  if (n.type === NotificationType.DEMO_POR_VENCER) return '/plataforma/empresas?demo=por-vencer';
  if (n.type === NotificationType.DEMO_VENCIDA) return '/plataforma/empresas?demo=vencida';
  // Landing nueva (vault 346): una solicitud de Mini Prixia → el panel, con las nuevas.
  if (n.type === NotificationType.SOLICITUD_MINI_PRIXIA)
    return '/plataforma/solicitudes?estado=NUEVA';
  if (n.strategyApplicationId) {
    return hrefsDeCompite.decisiones({ vuelta: n.strategyApplicationId });
  }
  // Monitoreo (25-oct): la competencia cambió precios → la revisión, abierta.
  if (n.monitorRunId) return hrefsDeCompite.monitoreo({ corrida: n.monitorRunId });
  if (n.type === NotificationType.COMPETITOR_PRICE_CHANGE) return hrefsDeCompite.monitoreo();
  return null;
}
